import styles from "./Summary.module.css";
import ContactButton from "shared/components/Buttons/ContactButton/ContactButton";
import SectionHeader from "shared/components/Header/SectionHeader";
import TechLogos from "shared/components/LogoRow/TechLogoRow";
import { useNavigate } from "react-router-dom";
import { trackCtaClick } from "shared/services/analytics";
import { useFetch } from "shared/utils/useFetch";

const defaultStats = { yearsExperience: 4, projects: 12, clients: 5 };

const Summary = () => {
  const navigate = useNavigate();
  const { data: profile } = useFetch("/api/profile", { stats: defaultStats });

  const stats = profile?.stats || defaultStats;

  const handleClick = () => {
    trackCtaClick("my_work");
    navigate("/projects");
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <SectionHeader
          isTextBold={true}
          title="Transforming Your Ideas into Reality"
        />
        <p className={styles.description}>
          Passionate about creating intuitive and engaging user experiences.
          Specialize in transforming ideas into beautifully crafted products
        </p>
        <div className={styles.stats}>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>+{stats.yearsExperience}</span>
            <span className={styles.statLabel}>YEARS OF EXPERIENCE</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>+{stats.projects}</span>
            <span className={styles.statLabel}>PROJECTS COMPLETED</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>+{stats.clients}</span>
            <span className={styles.statLabel}>WORLDWIDE CLIENTS</span>
          </div>
        </div>
        <div className={styles.buttonRow}>
          <ContactButton />
          <button onClick={handleClick} className={styles.linkButton}>
            <span className={styles.statLabel}>My Work &#8594;</span>
          </button>
        </div>
      </div>
      <div className={styles.animatedRow}>
        <TechLogos />
      </div>
    </div>
  );
};

export default Summary;
